import { api } from "./api";

export interface ApiKey {
  id: string;
  name: string;
  prefix: string;
  scopes: string[];
  lastUsedAt: string | null;
  expiresAt: string | null;
  revokedAt: string | null;
  createdAt: string;
}

export interface ApiKeyListResponse {
  entitled: boolean;
  keys: ApiKey[];
}

/**
 * One module of the public API, with its read and write scope. The server owns this
 * list; the UI only labels it (`apiKeys.groups.<id>`), so a module added on the API
 * side shows up here without a frontend release.
 */
export interface ApiScopeGroup {
  id: string;
  scopes: string[];
}

export interface ApiScopeResponse {
  scopes: string[];
  groups: ApiScopeGroup[];
}

export const apiKeysApi = {
  scopes: () => api.get<ApiScopeResponse>("/account/api-keys/scopes"),
  list: () => api.get<ApiKeyListResponse>("/account/api-keys"),
  create: (name: string, scopes: string[]) =>
    api.post<{ key: ApiKey; fullKey: string }>("/account/api-keys", { name, scopes }),
  revoke: (id: string) => api.del<void>(`/account/api-keys/${id}`),
};
